import Vue from 'vue'
import VueRouter from 'vue-router'
import Location from "../views/Location";
import product from '../views/product.vue'
import shop from '../views/shop.vue'
import city from '../views/city.vue'
import order from '../views/orderInfo'
import adc from '../views/adc'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/location'
  },
  {
    path: '/location',
    name: 'location',
    component: Location
  },
  {
    path: '/shop',
    name: 'shop',
    component: shop
  },
  {
    path: '/item',
    name: 'item',
    component: product
  },
  {
    path: '/city',
    name: 'city',
    component: city
  },
  {
    path: '/order',
    name: 'order',
    component: order
  },
  {
    path: '/adc',
    name: 'adc',
    component: adc
  },


]

const router = new VueRouter({
  //mode: 'history',
  //base: process.env.BASE_URL,
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查目标路由是否与当前路由相同
  if (to.path === from.path) {
    // 相同路径，忽略导航，避免 NavigationDuplicated 错误
    console.log('Ignored redundant navigation to:', to.path);
    // 不调用 next()，因为不需要进行实际的导航
  } else {
    // 不同路径，正常执行导航
    next();
  }
});

export default router
